module.exports = __webpack_public_path__ + "img/littlecar_right.7f9a4557.png";